<template>
  <div class="About container">
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <div class="tile is-child box">
          <h1 class="title is-2">{{ $t('about.message') }}</h1>
          <h3 class="subtitle is-4">{{ $t('about.sub-title') }}</h3>
        </div>
      </div>
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <div class="tile is-child box">
          <p class="title">{{ $t('about.title-senior') }}</p>
          <p class="subtitle">{{ $t('about.desc-senior') }}</p>
        </div>
      </div>
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <div class="tile is-child box">
          <p class="title">{{ $t('about.title-how-work') }}</p>
          <p class="subtitle" v-html="$t('about.desc-how-work')"></p>
        </div>
      </div>
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <div class="tile is-child box">
          <p class="title">{{ $t('about.title-free-time') }}</p>
          <p class="subtitle" v-html="$t('about.desc-free-time')"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About"
}
</script>

<style lang="scss">
.About {
  margin-top: 4em !important;

  .box {
    background-color: $background;
    box-shadow: none;
  }
}
</style>
